import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=1dd26540&scoped=true"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&id=1dd26540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd26540",
  null
  
)

export default component.exports